import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';
import {Injectable} from '@angular/core';

interface IRouteConfigData {
  reuse: boolean;
}

@Injectable()
export class CachingRouteReuseStrategy implements RouteReuseStrategy {

  private routeCache = new Map<string, DetachedRouteHandle>();

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.getRouteData(route)?.reuse;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.routeCache.set(route.routeConfig.path, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.routeConfig && !!this.routeCache.get(route.routeConfig.path);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.routeCache.get(route.routeConfig.path);
  }

  private getRouteData(route: ActivatedRouteSnapshot): IRouteConfigData {
    return route.routeConfig && (route.routeConfig.data as IRouteConfigData);
  }

}

export interface OnAttach {
  /**
   * A callback method that is invoked when the RouteReuseStrategy instructs
   * to re-attach a previously detached component / subtree
   */
  onAttach(activatedRoute: ActivatedRoute): void;
}

export interface OnDetach {
  /**
   * A callback method that is invoked when the RouteReuseStrategy instructs
   * to detach component / subtree
   */
  onDetach(): void;
}
